import React, { useEffect, useState } from "react";
import ProductCard from "../../components/common/ProductCard";
import { productService } from "../../services/product.service";

/**
 * Popular Categories Section
 * Fetches products marked with `display_flags = popular`
 * and renders them using the reusable ProductCard component.
 */
const PopularCategories = ({
  onNavigate,
  onAddToCart,
  cartItems,
  onQuantityChange,
  onRemoveItem,
  favouriteItems,
}) => {
  const [products, setProducts] = useState([]);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchPopularProducts = async () => {
      try {
        const data = await productService.getByDisplayFlag("popular");

        // ✅ SAFETY NET: Double-check that we only render visible products
        // (Even if the backend fails to filter them, the frontend will catch it)
        const visibleProducts = data.filter(
          (product) => product.is_visible === true,
        );

        setProducts(visibleProducts);
      } catch (err) {
        console.error(err);
        setError("Failed to load popular categories");
      }
    };

    fetchPopularProducts();
  }, []);

  if (error) {
    return <p className="error-text">{error}</p>;
  }

  // ✅ OPTIONAL UI: What to show if there are no visible popular products?
  if (products.length === 0) {
    return null; // Or return a "Check back later!" message
  }

  return (
    <section className="page-section section-reveal">
      <h2 className="section-title">Popular Categories</h2>

      <div className="product-grid">
        {products.map((product) => (
          <ProductCard
            key={product._id}
            product={product}
            productId={product.product_id}
            onNavigate={onNavigate}
            onAddToCart={onAddToCart}
            cartItems={cartItems}
            onQuantityChange={onQuantityChange}
            onRemoveItem={onRemoveItem}
            favouriteItems={favouriteItems}
          />
        ))}
      </div>
    </section>
  );
};

export default PopularCategories;
